import { createStore } from '../createStore';

export interface LauncherStatesData {
  isAppInstalled: boolean;
  isAppUpdateAvailable: boolean;
  doesAppNeedRepair: boolean;
  isAppRunning: boolean;

  isAnyTaskInProgress: boolean;
  isInstallTaskInProgress: boolean;
  isUpdateTaskInProgress: boolean;
  isRepairTaskInProgress: boolean;
  isMoveTaskInProgress: boolean;
  isUninstallTaskInProgress: boolean;

  isAnyTaskPaused: boolean;
  isInstallTaskPaused: boolean;
  isUpdateTaskPaused: boolean;
  isRepairTaskPaused: boolean;
  isMoveTaskPaused: boolean;
  isUninstallTaskPaused: boolean;

  hasAnyTaskFailed: boolean;
  hasInstallTaskFailed: boolean;
  hasUpdateTaskFailed: boolean;
  hasRepairTaskFailed: boolean;
  hasMoveTaskFailed: boolean;
  hasUninstallTaskFailed: boolean;

  failReason: 'unknownError' | 'noDiskSpace' | 'noPermission' | 'noInternet';
}

export const launcherStatesAllFalse: LauncherStatesData = {
  isAppInstalled: false,
  isAppUpdateAvailable: false,
  doesAppNeedRepair: false,
  isAppRunning: false,

  isAnyTaskInProgress: false,
  isInstallTaskInProgress: false,
  isUpdateTaskInProgress: false,
  isRepairTaskInProgress: false,
  isMoveTaskInProgress: false,
  isUninstallTaskInProgress: false,

  isAnyTaskPaused: false,
  isInstallTaskPaused: false,
  isUpdateTaskPaused: false,
  isRepairTaskPaused: false,
  isMoveTaskPaused: false,
  isUninstallTaskPaused: false,

  hasAnyTaskFailed: false,
  hasInstallTaskFailed: false,
  hasUpdateTaskFailed: false,
  hasRepairTaskFailed: false,
  hasMoveTaskFailed: false,
  hasUninstallTaskFailed: false,

  failReason: 'unknownError',
};

export const [LauncherStatesStoreProvider, useLauncherStatesStore] = createStore<LauncherStatesData>({
  ...launcherStatesAllFalse,
});

export const launcherStatesOrder = [
  'isAppInstalled',
  'isAppUpdateAvailable',
  'doesAppNeedRepair',
  'isAppRunning',

  'isAnyTaskInProgress',
  'isInstallTaskInProgress',
  'isUpdateTaskInProgress',
  'isRepairTaskInProgress',
  'isMoveTaskInProgress',
  'isUninstallTaskInProgress',

  'isAnyTaskPaused',
  'isInstallTaskPaused',
  'isUpdateTaskPaused',
  'isRepairTaskPaused',

  'hasAnyTaskFailed',
  'hasInstallTaskFailed',
  'hasUpdateTaskFailed',
  'hasRepairTaskFailed',
  'hasMoveTaskFailed',
  'hasUninstallTaskFailed',

  'failReason',
] as unknown as (keyof LauncherStatesData)[];
